import type { CreditLimitTransferRow } from './clTransfersTypes'

/**
 * Deterministic fixture for demo / offline. Shaped like Winner
 * CreditLimitLogs/searchCreditLimitLogs result rows.
 */
export const DEMO_CL_TRANSFERS: CreditLimitTransferRow[] = [
  {
    id: 'cl-1',
    createdAt: '2026-08-18T09:12:04.000Z',
    fromUsername: 'zintm1',
    toUsername: 'zinrtest1',
    creditLimit: 2_500_000,
    balance: 1_840_250.5,
    oldBalance: 1_200_000,
    clientIp: '103.21.244.12',
  },
  {
    id: 'cl-2',
    createdAt: '2026-08-17T14:41:22.000Z',
    fromUsername: 'zinrtest1',
    toUsername: 'rk.sm01',
    creditLimit: 500_000,
    balance: 412_000,
    oldBalance: 350_000,
    clientIp: '49.36.112.88',
  },
  {
    id: 'cl-3',
    createdAt: '2026-08-16T11:05:51.000Z',
    fromUsername: 'rk.sm01',
    toUsername: 'rk.mn04',
    creditLimit: 150_000,
    balance: 98_440.25,
    oldBalance: 75_000,
    clientIp: '122.162.45.19',
  },
  {
    id: 'cl-4',
    createdAt: '2026-08-15T18:22:09.000Z',
    fromUsername: 'zintm1',
    toUsername: 'zinrtest2',
    creditLimit: 1_800_000,
    balance: 1_800_000,
    oldBalance: 1_500_000,
    clientIp: '103.21.244.12',
  },
  {
    id: 'cl-5',
    createdAt: '2026-08-14T07:55:33.000Z',
    fromUsername: 'rk.mn04',
    toUsername: 'demo@fancy',
    creditLimit: 10_000,
    balance: 6_250,
    oldBalance: 2_500,
    clientIp: '157.48.201.4',
  },
  {
    id: 'cl-6',
    createdAt: '2026-08-13T16:08:17.000Z',
    fromUsername: 'zinrtest1',
    toUsername: 'rk.sm02',
    creditLimit: 400_000,
    balance: 290_100,
    oldBalance: 400_000,
    clientIp: '49.36.112.88',
  },
  {
    id: 'cl-7',
    createdAt: '2026-08-12T10:31:44.000Z',
    fromUsername: 'rk.sm02',
    toUsername: 'rk.mn11',
    creditLimit: 100_000,
    balance: 55_000,
    oldBalance: 80_000,
    clientIp: '122.162.45.19',
  },
  {
    id: 'cl-8',
    createdAt: '2026-08-11T13:19:02.000Z',
    fromUsername: 'w7ops',
    toUsername: 'zintm1',
    creditLimit: 12_000_000,
    balance: 9_400_000,
    oldBalance: 10_000_000,
    clientIp: '10.0.0.4',
  },
]
